import { ArrowRight, Camera, Instagram } from "lucide-react";
import { FadeUp, RevealLinesOnView } from "../Reveal";
import { BRAND, IMG } from "../../lib/site";

const VALUES = ["Creativity", "Quality", "Precision", "Passion"];

const SERVICE_CARDS = [
  { title: "Photography", sub: "Weddings • Events • Portraits", image: IMG.photoWedding },
  { title: "Videography", sub: "Events • Wedding Films • Corporate", image: IMG.photoVideography },
  { title: "Product Photography", sub: "Products • Brands • Campaigns", image: IMG.photoProduct },
];

function About() {
  return (
    <section data-testid="about-brand" className="bg-neutral-50 py-24 md:py-32">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-6">
            <p className="overline mb-6 text-pp-red">About PHOTO PIXEL®</p>
            <RevealLinesOnView lines={["MORE THAN A PHOTO.", "A MEMORY."]} className="font-display text-4xl font-black leading-[0.95] tracking-tight text-pp-ink md:text-6xl" />
          </div>
          <div className="md:col-span-5 md:col-start-8">
            <p className="text-lg leading-relaxed text-neutral-600">
              PHOTO PIXEL® is dedicated to transforming photographs into beautiful prints, premium frames, personalized gifts and timeless wall art.
            </p>
            <div className="mt-10 grid grid-cols-2 gap-6">
              {VALUES.map((v, i) => (
                <FadeUp key={v} delay={i * 0.08}>
                  <div className="border-t border-neutral-300 pt-4">
                    <span className="overline text-pp-red">0{i + 1}</span>
                    <p className="mt-2 font-display text-2xl font-bold text-pp-ink">{v}</p>
                  </div>
                </FadeUp>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// Secondary — catchy but clearly additional photography & videography services.
function Capture() {
  return (
    <section id="photography" data-testid="photography-section" className="scroll-mt-24 bg-pp-black noise py-24 text-white md:py-28">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        {/* Story transition */}
        <div className="mb-14 grid grid-cols-1 gap-10 md:grid-cols-12 md:items-end">
          <div className="md:col-span-7">
            <p className="overline mb-5 flex items-center gap-2 text-pp-red"><Camera size={14} /> Additional Services</p>
            <RevealLinesOnView lines={["AND YES,", "WE ALSO CAPTURE MOMENTS."]} className="font-display text-4xl font-black leading-[0.95] tracking-tight text-white md:text-6xl" />
          </div>
          <div className="md:col-span-5">
            <p className="font-display text-xl italic leading-relaxed text-white/85 md:text-2xl">
              We print your memories. We frame them. And when you need us, we capture them too.
            </p>
            <p className="mt-4 text-sm text-white/55">Professional photography and videography for the moments you want to remember.</p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {SERVICE_CARDS.map((c, i) => (
            <FadeUp key={c.title} delay={i * 0.1}>
              <a href={BRAND.social.storiesInsta} target="_blank" rel="noreferrer" data-testid={`photography-card-${i}`} data-cursor="view" className="group relative block h-[380px] overflow-hidden">
                <img src={c.image} alt={c.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1100ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-pp-black via-pp-black/20 to-transparent" />
                <span className="absolute left-6 top-6 h-0.5 w-0 bg-pp-red transition-all duration-500 group-hover:w-12" />
                <div className="absolute inset-x-0 bottom-0 p-6 transition-transform duration-500 group-hover:-translate-y-1">
                  <h3 className="font-display text-2xl font-bold text-white">{c.title}</h3>
                  <p className="mt-1 text-sm text-white/60">{c.sub}</p>
                  <span className="mt-3 inline-flex items-center gap-2 overline text-pp-red opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                    Explore <ArrowRight size={14} />
                  </span>
                </div>
              </a>
            </FadeUp>
          ))}
        </div>

        {/* Photographic services Instagram */}
        <div id="videography" className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 md:flex-row md:items-center">
          <p className="overline text-white/50">Our Photographic Services</p>
          <a href={BRAND.social.storiesInsta} target="_blank" rel="noreferrer" data-testid="photography-instagram" className="pp-btn rounded-full border border-white/25 px-6 py-3 text-sm text-white hover:border-pp-red hover:bg-pp-red">
            <Instagram size={16} /> {BRAND.social.storiesHandle}
          </a>
        </div>
      </div>
    </section>
  );
}

export default function Secondary() {
  return (
    <>
      <Capture />
      <About />
    </>
  );
}
